import { createAction, props } from '@ngrx/store';
import {FilterItem} from '../../../projektverwaltung/filter.model';
import {DialogData} from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import {FilterSucheItem} from "../../filterSucheModel";

export const getFilteredSeekDateStart = createAction('ZEIT::GET_FILTERED_SEEK_DATE_START', props<{ string: string, item: FilterSucheItem }>());
export const getFilteredSeekDateSucceeded = createAction('ZEIT::GET_FILTERED_SEEK_DATE_SUCCEEDED', props<{ item: DialogData[] }>());
export const getFilteredSeekDateFailed = createAction('ZEIT::GET_FILTERED_SEEK_DATE_FAILED', props<{ error: Error }>());
